import {
    Modal,
    Label,
    Button,
    CloseIcon,
    Input,
    TextArea,
    Checkbox,
    CardContent,
    Card,
    Table,
    TableHead,
    TableRow,
    TableHeaderCell,
    TableBody,
    TableCell,
    TextOverflow
} from "@forge/common";
import { CREATE_COURSE_CONSTANTS } from "../utils/constants";
import { IVAPPVMTableHeader, ViewVMTemplateProps } from "../model/index";
import "./view-vm-template.scss";
import "../../create-course/create-course.scss";

const ViewVMExistingTemplate = ({ isOpen, viewVmObj, onClose }: ViewVMTemplateProps) => {
    if (!isOpen) return null;
    const tableHeaders: IVAPPVMTableHeader[] = [
        { id: "vAppTemplate", name: "VAPP TEMPLATE NAME" },
        { id: "name", name: "NAME" },
        { id: "osType", name: "OS TYPE" },
        { id: "osVersion", name: "OS VERSION" },
        { id: "ram", name: "RAM" },
        { id: "cpu", name: "CPU" },
        { id: "vmPausable", name: "VM PAUSABLE" },
        { id: "ipAddress", name: "IP ADDRESS" },
        { id: "storage", name: "STORAGE" },
    ];
    return (
        <>
            <Modal
                className="modal-wh"
                fullContent={true}
                backdrop={true}
                data-testid="view-vm-details-modal"
                onBackdropClick={() => { }}
                onModalClose={onClose}
            >
                <div className="modal-header">
                    <div className="modal-header-left">
                        <Label className="modal-title">View VM</Label>
                    </div>
                    <div className="modal-header-right flex items-center gap-4">
                        <Button
                            className="text-xs close-icon"
                            id="close-view-vm-modal"
                            data-testid="close-view-vm-modal"
                            icon={<CloseIcon strokeWidth={2} />}
                            onClick={onClose}
                            size="regular"
                            variant="quiet-primary"
                            aria-label="Close View VM"
                            iconPosition="right"
                        />
                    </div>
                </div>
                <div className="modal-body">
                    <div className="flex gap-10">
                        <div className="w-[413px]">
                            <Label required className="createCourse-label mb-2">
                                {CREATE_COURSE_CONSTANTS.CREATE_VM_MODAL.VM_NAME.LABEL}
                            </Label>
                            <Input
                                id="view-vm-name"
                                className={`createCourse-name-input-field !border-none`}
                                data-testid="view-vm-name"
                                size="regular"
                                placeholder="VM Name"
                                value={viewVmObj.vmName}
                                disabled
                            />
                            <div className="mt-8">
                                <Checkbox
                                    id="view-vm-auto-pause"
                                    className="new-vm-input"
                                    data-testid="view-vm-auto-pause"
                                    checked={viewVmObj.vmPause === 'Yes' ? true : false}
                                    disabled
                                >
                                    {CREATE_COURSE_CONSTANTS.CREATE_VM_MODAL.ALLOW_AUTO_PAUSE}
                                </Checkbox>
                            </div>
                        </div>
                        <div className="w-[413px]">
                            <Label className="createCourse-label mb-2">
                                {CREATE_COURSE_CONSTANTS.CREATE_VM_MODAL.DESCRIPTION.LABEL}
                            </Label>
                            <TextArea
                                id="view-vm-description"
                                className={`createCourse-description-input-field no-resize !border-none`}
                                data-testid="view-vm-description"
                                placeholder="Description"
                                rows={3}
                                size="regular"
                                disabled
                                value={viewVmObj.vmDescription}
                            />
                        </div>
                    </div>
                    <div className="mt-4 b-top-1">
                        <Label className="text-sm mt-4 mb-2">
                            {'Selected Template'}
                        </Label>
                        <div>
                            <Card className="border-unset mt-4">
                                <div className="view-vm-table">
                                    <CardContent x="none" y="none">
                                        <Table onCard>
                                            <TableHead>
                                                <TableRow>
                                                    {tableHeaders.map((header: IVAPPVMTableHeader) => (
                                                        <TableHeaderCell
                                                            className="text-sm vpp-table-border !max-w-[90px]"
                                                            key={header.id}
                                                            id={header.id}
                                                            data-testid={header.name}
                                                        >
                                                            {header.name}
                                                        </TableHeaderCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell className="table-body-cell !max-w-[110px]">
                                                        <TextOverflow>{viewVmObj.vAppTemplateName}</TextOverflow>
                                                    </TableCell>
                                                    <TableCell className="table-body-cell !max-w-[110px]">
                                                        <TextOverflow>{viewVmObj.vAppTempVmname}</TextOverflow>
                                                    </TableCell>
                                                    <TableCell className="table-body-cell">
                                                        <TextOverflow>{viewVmObj.osType}</TextOverflow>
                                                    </TableCell>
                                                    <TableCell className="table-body-cell !max-w-[110px]">
                                                        <TextOverflow>{viewVmObj.osVersion}</TextOverflow>
                                                    </TableCell>
                                                    <TableCell className="table-body-cell">
                                                        <TextOverflow>{`${viewVmObj.ram} MB`}</TextOverflow>
                                                    </TableCell>
                                                    <TableCell className="table-body-cell">
                                                        <TextOverflow>{`${viewVmObj.cpu} ${viewVmObj.cpu === "1" ? "Core" : "Cores"}`}</TextOverflow>
                                                    </TableCell>
                                                    <TableCell className="table-body-cell">
                                                        <TextOverflow>{viewVmObj.vAppTempAutoPause}</TextOverflow>
                                                    </TableCell>
                                                    <TableCell className="table-body-cell !max-w-[100px]">
                                                        <TextOverflow>{viewVmObj.vAppTempVmIP === "" ? "--" : viewVmObj.vAppTempVmIP}</TextOverflow>
                                                    </TableCell>
                                                    <TableCell className="table-body-cell">
                                                        <TextOverflow>{`${viewVmObj.storage} GB`}</TextOverflow>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </CardContent>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
export default ViewVMExistingTemplate;
